/* Keep changing native report options and their footer within the viewport. */
(function (window, document) {
    'use strict';
    var lx = window.lx = window.lx || {};
    if (lx.nativeReportDialogs) return;
    var states = new WeakMap(), initialized = false;

    function position(content) {
        var state = states.get(content);
        if (!state || state.frame) return;
        state.frame = window.requestAnimationFrame(function () {
            state.frame = 0;
            var dialog = window.apex.jQuery(content);
            if (content.isConnected && dialog.is(':visible') && dialog.dialog('isOpen')) {
                dialog.dialog('option', 'position', {my:'center', at:'center', of:window, collision:'fit'});
            }
        });
    }

    function watch(content) {
        if (states.has(content)) return position(content);
        var state = {frame:0, observer:null};
        states.set(content, state);
        if (window.ResizeObserver) {
            state.observer = new ResizeObserver(function () { position(content); });
            state.observer.observe(content.closest('.a-IRR-dialog'));
        }
        position(content);
    }

    function release(content) {
        var state = states.get(content);
        if (!state) return;
        if (state.observer) state.observer.disconnect();
        if (state.frame) window.cancelAnimationFrame(state.frame);
        states.delete(content);
    }

    function init() {
        if (initialized || !window.apex || !window.apex.jQuery) return;
        initialized = true;
        window.apex.jQuery(document)
            .on('dialogopen.lpReportDialogs', '.a-IRR-dialogBody', function () { watch(this); })
            .on('dialogclose.lpReportDialogs', '.a-IRR-dialogBody', function () { release(this); })
            .on('change.lpReportDialogs', '.a-IRR-dialogBody :input', function () { position(this.closest('.a-IRR-dialogBody')); });
    }

    lx.nativeReportDialogs = {init:init};
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})(window, document);
